// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"1c1e971f","699":"1c1e971f"}[chunkId] + ".chunk.css";
};